<template>
    <!-- 注意：逻辑部分尽量不好写到这个组件内，因为这个组件是根据外面table循环创建的，在这里写逻辑会非常影响性能 -->
    <div 
        class="customHeader inline-block  ver-middle" 
        @click.stop
        :style="item.sortable ? {} :{ maxWidth: '100%' }"
    >
        <el-popover
            placement="bottom"
            :title="item.name"
            :width="item.colType == 'content'?500:400"
            trigger="click"
            ref="popover"
            :key="'header-'+item.name"
            @show="showPopper"
            @hide="handleHidePop"
            popper-class="table-header-filter-popper"
            :disabled="item.field=='index'"
        >
            <!-- txt 文本 -->
            <div class="font12px" v-if="item.colType == 'content'">
                <div class="clearfix">
                    <div class="search-wrap fl">
                        <div>
                            <el-input v-model="search" ref="searchInput" @input="inputSearchText" @clear="clearSearchText" @keyup.enter.native="changeSearchText" clearable placeholder="输入查询关键字">
                                <template slot="append">
                                    <span class="el-icon-search pointer" @click="changeSearchText"></span>
                                </template>
                            </el-input>
                            <div class="search-list" v-loading="searchLoading" @scroll="scrollList">
                                <!-- 有自动加载 -->
                                <ul v-if="isAutoLoad">
                                    <li class="mt4 mb4" v-if="dataList.length>0&&!!lastSearchText">
                                        <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox>
                                    </li>
                                    <li class="mt4 mb4" v-for="item in dataList" :key="item.id+item.name"
                                        :class="(isAutoLoad||(!isAutoLoad&&(item.name||'').includes(search)))?'':'hide-item'">
                                        <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                            {{item.name}}
                                        </el-checkbox>
                                    </li>
                                    <li class="mt4 mb4" v-if="!searchLoading&&isAutoLoad&&dataList.length<=0">
                                        <p class="tac">暂无数据</p>
                                    </li>
                                    <li class="mt4 mb4" v-if="!isAutoLoad&&dataList.some(inner=>!(inner.name||'').includes(search))">
                                        <p class="tac">暂无数据</p>
                                    </li>
                                    <li class="mt4 mb4" v-if="searchLoading">
                                        <p class="tac text-color-gray">数据加载中...</p>
                                    </li>
                                    <li class="mt4 mb4" v-if="isEnd">
                                        <p class="tac text-color-gray">没有更多了</p>
                                    </li>
                                </ul>
                                <!-- 无自动加载 -->
                                <ul v-else>
                                    <li class="mt4 mb4" v-if="dataList.some(inner=>(inner.name||'').includes(search))">
                                        <el-checkbox v-model="isSelectAll" @change="selectAll">全选</el-checkbox>
                                    </li>
                                    <li class="mt4 mb4" v-for="item in dataList" :key="item.id+item.name"
                                        :class="(item.name||'').includes(search)?'':'hide-item'">
                                        <el-checkbox v-model="item.checked" @change="itemCheckChange(item,$event)">
                                            {{item.name}}
                                        </el-checkbox>
                                    </li>
                                    <li class="mt4 mb4" v-if="!searchLoading&&dataList.every(inner=>!(inner.name||'').includes(search))">
                                        <p class="tac">暂无数据</p>
                                    </li>
                                    <li class="mt4 mb4" v-if="searchLoading">
                                        <p class="tac text-color-gray">数据加载中...</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="result-wrap fl">
                        <h3 class="font12px relative">已选条件（{{resultList.length}}） <span
                            class="text-color-error pointer absolute " style="right:10px;"
                            @click="clearResultList">清空</span>
                        </h3>
                        <div class="result-list">
                            <ul>
                                <li v-for="item in resultList" :key="item.id" class="relative mt4 mb4 font12px">
                                    {{item.name}}
                                    <span class="clear-btn pointer text-color-error p4 absolute"
                                          @click="clearResultItem(item)"
                                          title="删除">x</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- scope 范围-->
            <div class="font12px" v-else-if="item.colType == 'number'">
                <div>
                    <p class="mb6">设置数据范围</p>
                    <el-select v-model="numberValue.calcType" @change="changeCalcType" clearable placeholder="请选择" size="mini" class="mr10"
                               style="width: 100px;">
                        <el-option label="大于等于" value="greater_than"></el-option>
                        <el-option label="大于" value="greater"></el-option>
                        <!--<el-option label="等于" value="equal"></el-option>-->
                        <el-option label="小于等于" value="less_than"></el-option>
                        <el-option label="小于" value="less"></el-option>
                        <el-option label="介于" value="between"></el-option>
                        <el-option label="等于0" value="eq0"></el-option>
                        <el-option label="不等于0" value="neq0"></el-option>
                    </el-select>
                    <el-input-number v-model="numberValue.num1" @change="handleChangeNum1" v-if="numberValue.calcType!='eq0'&&numberValue.calcType!='neq0'" :precision="2" size="mini" placeholder="请输入"
                                     :controls="false" style="width: 100px;"></el-input-number>
                    <span v-if="numberValue.calcType=='between'" class="ml10 mr10">-</span>
                    <el-input-number v-if="numberValue.calcType=='between'" v-model="numberValue.num2"
                                     @change="handleChangeNum2" size="mini" :precision="2" :controls="false" placeholder="请输入"
                                     style="width: 100px;"></el-input-number>
                    <span v-if="isRate" class="ml4">%</span>
                </div>
            </div>

            <!-- confirm 确定框-->
            <div class="tac">
                <el-button @click="confirm" type="primary" size="mini" class="confirm"
                >确定
                </el-button
                >
            </div>
            <!--      onselectstart="return false"
                oncontextmenu="return false"-->
            <div
                slot="reference"

                class="label table-custom-filter-label"
                :class="{ labelColor: tableFilterList.map(inner=>inner.field).includes(item.field) }"
                style="white-space: initial;"
            >
                <el-tooltip class="item" :disabled="item.field=='index'" effect="dark" :content="item.name" placement="top-start">
                    <span class="table-header-col-title" :data-title="item.name">{{item.name}}</span>
                </el-tooltip>
                <i class="el-icon-arrow-down" v-if="item.field!='index'"></i>
            </div>
        </el-popover>
    </div>
</template>
<script>
    import utils from '@/libs/utils.js';
    import API from '@/api/dataCenter.js';
    export default {
        name: "CustomTableHeader",
        // column 当前列数据，tableConfig 内数据，customParams 下拉框数据， labelColorList 正在使用的筛选条件
        props: [
            "platId",
            "condition",
            "excludeConditionFields",
            "formField",
            "formGroup",
            "rangeTime",
            "rangeTime1",
            "compareType",
            "dataDisplayType",
            "costType",
            "autoLoadFields",
            "isTimeFilter",
            "timeInterval",
            "item",
            "tableFilterList",
            "timeZone"
        ],
        data() {
            return {
                isSelectAll: false,
                resultList: [],
                search: '',
                numberValue: {
                    calcType: 'greater_than',
                    num1: undefined,
                    num2: undefined,
                },
                dataList:[],
                searchLoading:false,
                isAutoLoad:false,
                searchTimer:null,
                isEnd:false,
                lastSearchText:'',
            };
        },
        computed:{
            isRate(){
                let name = this.item.name;
                return name.includes('率')||name.includes('ROI')||name.includes('roi')||name.includes('差值比');
            },
        },
        mounted(){
            let $table = document.querySelector('.data-table-wrap .el-table__body-wrapper');
            $table.addEventListener('scroll', this.hidePopover);
        },
        methods: {
            confirm() {
                // 关闭popover
                this.$refs.popover.doClose();

                let numVal = Object.assign({},{isRate:this.isRate},this.numberValue);
                let popVal = this.item.colType === 'content' ? this.resultList : numVal;
                this.$emit("tableUpdate", this.item, popVal);
            },
            hidePopover(){
                let $pop = this.$refs.popover;
                if($pop.showPopper===true){
                    $pop.showPopper = false;
                }
                this.search = '';
            },
            handleChangeNum1(val) {
                console.log('handleChangeNum1', val);
            },
            handleChangeNum2(val) {
                console.log('handleChangeNum2', val);
            },
            clearResultList() {
                this.resultList = [];
                this.dataList.forEach(item => {
                    item.checked = false;
                });
                this.isSelectAll = false;
            },
            clearResultItem(item) {
                let searchIndex = this.dataList.findIndex(inner => inner.id == item.id);
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (resultIndex != '-1') {
                    this.resultList.splice(resultIndex, 1);
                }
                if (searchIndex != '-1') {
                    this.dataList.find(inner => inner.id == item.id).checked = false;
                }
                this.resetAllState();
            },
            itemCheckChange(item, val) {
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (val) {
                    if (resultIndex == '-1') {
                        this.resultList.unshift(item);
                    }
                } else {
                    if (resultIndex != '-1') {
                        this.resultList.splice(resultIndex, 1);
                    }
                }
                this.resetAllState();
            },
            selectAll(val) {
                this.dataList.forEach(item => {
                    if(this.isAutoLoad){
                        if(!item.isHide){
                            item.checked = val;
                            this.itemCheckChange(item, val);
                        }
                    }else{
                        if(item.name.includes(this.search)){
                            item.checked = val;
                            this.itemCheckChange(item, val);
                        }
                    }
                });
                this.resetAllState();
            },
            resetAllState() {
                let selectedList = [];
                if(this.isAutoLoad){
                    this.isSelectAll = this.dataList.every(item => item.checked);
                }else{
                    selectedList = this.dataList.filter(item=> (item.name||'').includes(this.search));
                    console.log('selectedList',selectedList);
                    this.isSelectAll = selectedList.length>0&&selectedList.every(item => item.checked);
                }
            },
            clearSearchText(){
                let val = this.search;
                if(!this.isAutoLoad){
                    this.dataList.forEach(item=>{
                        item.isHide = !(item.name||'').toLowerCase().includes(val.toLowerCase());
                    });
                    this.resetAllState();
                }else{
                    this.changeSearchText();
                }
            },
            changeSearchText() {
                let val = this.search;
                if(this.isAutoLoad){
                    if(this.searchTimer){
                        clearTimeout(this.searchTimer);
                        this.searchTimer = null;
                    }
                    this.searchTimer = setTimeout(()=>{
                        this.dataList = [];
                        this.getDataList();
                    },300)
                }else{
                    this.dataList.forEach(item=>{
                        item.isHide = !(item.name||'').toLowerCase().includes(val.toLowerCase());
                    });
                    this.resetAllState();
                }
            },
            inputSearchText(){
                if(this.isAutoLoad) return false;
                this.resetAllState();
            },
            scrollList(e){
                if(this.search!='') return;
                if(!this.isAutoLoad) return;
                let $searchBox = e.target;
                let $ul = $searchBox.querySelector('ul');
                let $ulHeight = $ul.clientHeight;
                if($searchBox.scrollTop>0){
                    if($ulHeight-$searchBox.clientHeight<$searchBox.scrollTop-15){
                        // console.log('到底了');
                        if(this.autoLoading) return ;
                        if(this.isEnd) return;
                        if(this.searchTimer){
                            clearTimeout(this.searchTimer);
                            this.searchTimer = null;
                        }
                        this.searchTimer = setTimeout(()=>{

                            this.autoLoading = true;
                            this.getDataList('append');
                        },300)
                    }
                }
            },
            showPopper(){
                console.log('showPopper');
                let filterItem = this.tableFilterList.find(item=>item.field == this.item.field);
                if(filterItem){
                    let filterValue = utils.deepClone(filterItem.filterValue||{});
                    if(filterItem.colType=='number'){
                        this.numberValue.num1 = filterValue.num1;
                        this.numberValue.num2 = filterValue.num2;
                        this.numberValue.calcType = filterValue.calcType;
                    }else if(filterItem.colType=='content'){
                        this.resultList = filterValue||[];
                        this.resetAllState();
                        this.getDataList();
                    }
                }else{
                    this.resetForm();
                    if(this.item.colType=='content'){
                        this.getDataList();
                    }
                }
                this.isAutoLoad =  this.autoLoadFields.includes(this.item.field);
                this.$emit('show-popper',this.item.field)
            },
            getDataList(type){
                this.searchLoading = true;
                let conditions = JSON.parse(this.condition||"{}");

                if(!(type&&type==='append')){
                    this.dataList = [];
                }
                this.isEnd = false;

                let apiType = 'getPlatSecondConditions';
                if(this.platId == '1'){
                    apiType = 'getOPPOSecondConditions';
                }else if(this.platId == '3'){
                    apiType = 'getVivoSecondConditions';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiSecondConditions';
                }else if(this.platId == '7'){
                    apiType = 'getMiSecondConditions';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiSecondConditions';
                }else if(this.platId == '9'){
                    apiType = 'getAppleSecondConditions';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSSecondConditions';
                }else if(this.platId == '11'){
                    apiType = 'getHonorSecondConditions';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4SecondConditions';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalSecondConditions';
                }

                let searchText = this.search;
                this.lastSearchText = searchText;
                let reqData = {
                    search: searchText,
                    return_condition: this.item.field,
                    condition:conditions,
                    exclude_condition_fields:this.excludeConditionFields,
                    group:this.formGroup,
                    field:this.formField,
                    range_time: this.rangeTime,
                    range_time1: this.compareType?this.rangeTime1:'',
                    compare_type:this.compareType,
                    data_display_type:this.dataDisplayType,
                    cost_type:this.costType,
                    last:this.dataList.length>0&&this.isAutoLoad?this.dataList[this.dataList.length-1].id:'',
                };
                if(this.platId=='9'||!this.platId){
                    reqData.time_zone = this.timeZone;
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.timeInterval;
                }

                let calcMap = {
                    greater:'>',
                    greater_than:'>=',
                    equal:'=',
                    less:'<',
                    less_than:'<=',
                    between:'>=<=',
                    eq0:'=0',
                    neq0:'!=0',
                };
                reqData.where = this.tableFilterList.filter(item=>item.field!=this.item.field).map(item=>{
                    console.log(item);
                    let isAppleSOVDate = this.platId=='9'&&['impression_share','impression_rank','search_popularity','compare_impression_share','compare_impression_rank','compare_search_popularity'].includes(item.field);
                    let isGroup = item.colType==='content';

                    return {
                        field:item.field,
                        type:isGroup&&!isAppleSOVDate?'group':'data',
                        calc:isGroup?'':calcMap[item.filterValue.calcType],
                        val:isGroup?item.filterValue.map(inner=>inner.id):item.filterValue.num1,
                        val1:item.filterValue.num2,
                    }
                });

                API[apiType](reqData).then(res => {
                    console.log('getContentSearch',searchText);
                    this.searchLoading = false;
                    this.autoLoading = false;
                    let resData = (res.data||{}).list||[];

                    let $input = this.$refs.searchInput;
                    $input&&$input.focus();

                    if(searchText==this.search){
                        if(type&&type==='append'){

                            /* 当最后一个为空时,可能会触发无限自动加载，因此如果返回列表已经全部在列表中存在时，就认为到底了 */
                            let isAllInList = resData.map(item=>item.id).filter(item=>!!item).every(item=>this.dataList.map(item=>item.id).includes(item));
                            if(isAllInList||resData.length<=0){
                                clearTimeout(this.searchTimer);
                                this.searchTimer = null;
                                this.isEnd = true;
                            }
                            resData.forEach(item=>{
                                if(!this.dataList.map(item=>item.id).includes(item.id)){
                                    item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                    item.isHide = false;
                                    this.dataList.push(item)
                                }
                            });

                        }else {
                            this.dataList = resData.map(item=>{
                                item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                item.isHide = false;
                                return item;
                            })
                        }
                        this.resetAllState();
                    }
                }, (err) => {
                    console.log('getConditions error', err);
                    this.searchLoading = false;
                    this.autoLoading = false;
                    this.dataList = [];
                    // this.$message.error(err.info||'请求有误');
                    let errCondition = err.data || [];
                    if (errCondition.length > 0) {

                        let errStr = '';
                        errCondition.forEach(item=>{
                            errStr = errStr + `<p class="pb6"><span class="text-bold">${item.err_title}</span>${(item.err_msg||[]).join('，')}</p>`;
                        });
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${errStr}</div>`;

                        this.$confirm(htmlStr, '以下已选条件无权限', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else{
                        this.$message.error(err.info||'请求有误');
                    }
                });
            },
            resetForm(){
                this.resultList = [];
                this.dataList = [];
                this.isSelectAll = false;
                this.search = '';
                this.numberValue = {
                    calcType: 'greater_than',
                    num1: undefined,
                    num2: undefined,
                };
            },
            handleHidePop(){
                this.search = '';
                this.numberValue = {
                    calcType: 'greater_than',
                    num1: undefined,
                    num2: undefined,
                };
            },
            triggerPopover(){
                console.log('triggerPopover',this.$refs.popover);
                this.$refs.popover.doToggle();
            },
            changeCalcType(val){
                if(val=='eq0'||val=='neq0'){
                    this.numberValue.num1 = undefined;
                    this.numberValue.num2 = undefined;
                }else if(!val){
                    this.numberValue.calcType = 'greater_than';
                    this.numberValue.num1 = undefined;
                    this.numberValue.num2 = undefined;
                }
            }
        },
        destroyed() {
            let $table = document.querySelector('.data-table-wrap .el-table__body-wrapper');
            if($table){
                $table.removeEventListener('scroll', this.hidePopover);
            }
        }
    };
</script>
<style lang="scss" scoped>

    .confirm {
        margin-top: 10px;
    }

    /* 禁止双击选中文字 */
    .label {
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none !important; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
    }

    .labelColor {
        color: #409eff;
    }

    .result-wrap, .search-wrap {
        width: 50%;
        border: solid 1px #ccc;
        padding: 10px;
        height: 300px;
        overflow: hidden;
    }

    ::v-deep.search-wrap .el-input-group__append{
        padding: 0 10px;
    }

    .result-wrap {
        position: relative;
        left: -1px;
    }

    .result-list {
        margin-top: 5px;
        height: 265px;
        overflow-y: auto;

        li {
            white-space: normal;
            line-height: 20px;
            padding: 0 20px 0 10px;

            &:hover {
                background-color: #f8f8f9;
            }
        }

        .clear-btn {
            padding: 0 8px;
            right: 0;
            top: 0;
        }
    }


    .search-list {
        width: 100%;
        min-height: 200px;
        max-height: 250px;
        overflow-y: auto;
        padding: 6px;
    }

    .hide-item {
        display: none;
    }

    .customHeader{
        max-width: calc(100% - 36px);
        pointer-events: auto;
    }
    .table-custom-filter-label{
        user-select: text!important;
    }

</style>
